import VueRouter from 'vue-router';

export default function (router: VueRouter, id: string | null) {
  id ? router.push({ name: 'Authority', params: { id: id } }) : router.push({ name: 'NewAuthority' });
}
